import React from 'react';
import { StyledPlainButton } from './PlainButton.styled';

const PlainButton = ({ children, onClick }) => {
  return (
    <StyledPlainButton onClick={onClick}>
      <button className='plain-button'>
        {children}
      </button>
      <div className='plain-button-corner plain-button-corner-l' />
      <div className='plain-button-corner plain-button-corner-r' />
    </StyledPlainButton>
  )
};

export default PlainButton;

